import { FC } from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "common/ProtectedRoute";
import { Role } from "common/Constants";
import { PointPermission } from "./permissions";
import Point from "./components/Point";
import PointsList from "./components/PointsList";
import AddPoint from "./components/AddPoint";

export const PointsRouter: FC<{}> = () => {
  return (
    <Routes>
      {/* Creating a point is gated separately from browsing them. The gate hides a screen, it
          does not protect the table. The BFF and OrderApi authorize the create, and OrderApi
          validates the coordinate and the duplicate check regardless of what the browser
          sends. */}
      <Route
        path="/new"
        element={
          <ProtectedRoute roles={[Role.Admin, Role.LocationAdmin]} permissions={[PointPermission.CreatePoint]}>
            <AddPoint />
          </ProtectedRoute>
        }
      />
      <Route path="/:id" element={<Point />} />
      <Route index element={<PointsList />} />
    </Routes>
  );
};
